/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const popupform = () => {
  const parentPopup = document.querySelectorAll('.popup-wraper-form-js');
  const targetBtn = document.querySelector('.popup-form-js');
  const fileUrls = {};

  parentPopup.forEach(parent => {
    const allbtn = parent.querySelectorAll('.c-button');
    allbtn.forEach(btn => {
      if (btn.hasAttribute('download')) {
        // save all link in object
        const marker = btn.getAttribute('data-marker');
        const link = btn.getAttribute('href');
        if (marker && link) {
          fileUrls[marker] = link;
        }

        btn.addEventListener('click', e => {
          e.preventDefault();
          const submenuCandidate = document.querySelector(
            '.c-candidate-inf__menu',
          );
          if (targetBtn.classList.contains('is-active')) {
            targetBtn.classList.remove('is-active');
            // eslint-disable-next-line no-param-reassign
            if (submenuCandidate) {
              submenuCandidate.style.zIndex = '88';
            }
            document.querySelector('.c-header').style.zIndex = '1000';
            document.querySelector('.c-footer').style.zIndex = 'auto';
          } else {
            targetBtn
              .querySelector('form')
              .setAttribute(
                'data-file',
                e.currentTarget.getAttribute('data-marker'),
              );
            targetBtn.classList.add('is-active');
            // eslint-disable-next-line no-param-reassign
            document.querySelector('.c-header').style.zIndex = '1';
            document.querySelector('.c-footer').style.zIndex = '-1';
            if (submenuCandidate) {
              submenuCandidate.style.zIndex = '1';
            }
          }
        });
      }
    });
  });

  document.addEventListener('click', e => {
    if (e.target.classList.contains('popup-form-js')) {
      targetBtn.classList.remove('is-active');
      const submenuCandidate = document.querySelector('.c-candidate-inf__menu');
      if (submenuCandidate) {
        submenuCandidate.style.zIndex = '88';
      }
      document.querySelector('.c-header').style.zIndex = '1000';
      document.querySelector('.c-footer').style.zIndex = 'auto';
    }
  });
  const closePopup = document.querySelector('.close-popup-js');
  if (closePopup) {
    closePopup.addEventListener('click', e => {
      const submenuCandidate = document.querySelector('.c-candidate-inf__menu');
      if (submenuCandidate) {
        submenuCandidate.style.zIndex = '88';
      }
      targetBtn.classList.remove('is-active');
      document.querySelector('.c-header').style.zIndex = '1000';
      document.querySelector('.c-footer').style.zIndex = 'auto';
    });
  }

  // send form
  document.addEventListener(
    'wpcf7mailsent',
    event => {
      const fileMarker = event.target.getAttribute('data-file');
      if (fileMarker) {
        const filename = fileUrls[fileMarker].substring(
          fileUrls[fileMarker].lastIndexOf('/') + 1,
        );
        const link = document.createElement('a');
        link.href = fileUrls[fileMarker];
        link.download = filename;
        link.dispatchEvent(new MouseEvent('click'));
      }
    },
    false,
  );
};

export default popupform;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/popupform.js